import EditAbout from './EditAbout';
export default EditAbout;
